import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {
    CloseSvg,
    SendSvg,
    BotSvg,
    UserSvg,
    LoadingSvg
} from '../../svgFile/ChatbotSvgs';

const Chatbot = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [position, setPosition] = useState({
        left: null,
        top: 100,
        right: 0
    });
    const [isDragging, setIsDragging] = useState(false);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [quickActionTriggered, setQuickActionTriggered] = useState(false);
    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);
    const modalRef = useRef(null);
    const GEMINI_API_KEY = 'AIzaSyDiJO5VMmnL3FfkjzX1b6sGKPNhPSjHrcs';
    const GEMINI_API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-3-flash-preview:generateContent?key=${GEMINI_API_KEY}`;
    const websiteInformation = `
    WEBSITE NAME: "MySwagShack"
    TAGLINE: "Customize Your World, One Product at a Time"
    DOMAIN: www.myswagshack.com
    BUSINESS OVERVIEW:
    MySwagShack is a premium e-commerce platform specializing in personalized and customized products. We help customers create unique items with AI-generated designs, text personalization, and custom graphics.
    PRODUCT CATALOG:
    1. APPAREL:
       • T-Shirts: ₹499 - ₹1299 (Cotton, Premium Cotton, Polyester blends)
       • Hoodies: ₹899 - ₹1999 (Fleece, French Terry, Zip-up options)
       • Jerseys: ₹799 - ₹1699 (Sports, Team, Custom numbers)
       • Caps: ₹499 - ₹899 (Snapback, Dad hats, Baseball caps)
       • Sportswear: ₹699 - ₹1599 (Activewear, Gym wear, Team uniforms)
    2. ACCESSORIES:
       • Mugs: ₹299 - ₹599 (Ceramic, Travel, Magic color-change)
       • Phone Cases: ₹399 - ₹799 (iPhone, Samsung, All models)
       • Bags: ₹599 - ₹1299 (Tote, Backpack, Messenger)
       • Keychains: ₹199 - ₹399 (Acrylic, Metal, Leather)
       • Laptop Skins: ₹499 - ₹899 (Vinyl, 3M materials)
    3. OFFICE & STATIONERY:
       • Notebooks: ₹199 - ₹499 (Hardcover, Softcover, Bullet journals)
       • Pens: ₹149 - ₹349 (Ballpoint, Gel, Fountain)
       • Mousepads: ₹299 - ₹599 (Extended, Gaming, Desk mats)
       • Desk Organizers: ₹799 - ₹1599 (Wood, Acrylic, Metal)
       • Business Cards: ₹299 per 100 pieces
    4. HOME DECOR:
       • Cushions: ₹399 - ₹899 (Various sizes, Premium fabrics)
       • Wall Art: ₹699 - ₹1999 (Canvas, Framed, Metal prints)
       • Coasters: ₹249 - ₹499 (Cork, Ceramic, Marble)
       • Photo Frames: ₹299 - ₹799 (Wood, Digital, Collage)
       • Blankets: ₹899 - ₹1899 (Fleece, Sherpa, Weighted)
    CUSTOMIZATION OPTIONS:
    1. AI LOGO GENERATOR (₹99 per item):
       • Generate 5 unique logo concepts
       • Styles: Minimalist, Modern, Classic, Abstract, Professional
       • Color customization
       • Transparent PNG download
       • Direct application to products
    2. TEXT PERSONALIZATION (₹49 per line):
       • Names, nicknames, initials
       • Quotes, messages, dates
       • Multiple font styles (15+ options)
       • Text effects (Shadow, Outline, 3D)
       • Color matching with products
    3. NUMBER PRINTING (₹79 per number):
       • Numbers 0-99
       • Sports jersey numbers
       • Anniversary dates
       • Special combinations
       • Font styles for numbers
    4. DESIGN UPLOAD (₹99 per design):
       • Accepts: PNG, JPG, JPEG, SVG, AI, PSD
       • Minimum resolution: 300 DPI
       • Transparent background preferred
       • Color correction available
       • Design positioning tools
    CUSTOMIZATION PROCESS - STEP BY STEP:
    1. BROWSING:
       • Visit website → Browse categories → Filter by price/type
       • Use search function for specific products
       • View product galleries with examples
    2. SELECTION:
       • Click on desired product → View details page
       • Select size/color options
       • Click "Customize This Product" button
    3. CUSTOMIZATION EDITOR:
       a) CHOOSE CUSTOMIZATION TYPE:
          • "AI Logo Generator" - Create new logo
          • "Add Text" - Type personalized text
          • "Add Numbers" - Enter numbers
          • "Upload Design" - Upload own file
       b) CUSTOMIZATION TOOLS:
          • Drag & drop positioning
          • Resize handles
          • Rotation tool
          • Layer management
          • Real-time 3D preview
          • Color picker
       c) PREVIEW & ADJUST:
          • 360° product view
          • Zoom in/out
          • Compare with original
          • Save draft design
    4. ADD TO CART:
       • Review final design
       • Select quantity
       • Add to shopping cart
       • Continue shopping or checkout
    AI LOGO GENERATOR DETAILS:
    PROCESS:
    1. Enter keywords (business name, style, colors)
    2. AI generates 5 logo concepts (different styles)
    3. Select preferred concept
    4. Customize colors, layout, elements
    5. Download as PNG with transparent background
    6. Apply directly to selected product
    FEATURES:
    • Multiple design variations
    • Editable vector elements
    • Color palette suggestions
    • Font pairing recommendations
    • Brand identity guidance
    • Save designs to account
    PRICING DETAILS:
    BASE PRODUCT PRICES:
    • T-shirts: ₹499 (Basic), ₹799 (Premium), ₹1299 (Organic)
    • Hoodies: ₹899 (Pullover), ₹1299 (Zip-up), ₹1999 (Premium)
    • Mugs: ₹299 (11oz), ₹399 (15oz), ₹599 (Travel mug)
    • Phone Cases: ₹399 (Basic), ₹599 (Shockproof), ₹799 (Designer)
    CUSTOMIZATION CHARGES:
    • AI Logo/Image Upload: ₹99 per item
    • Text Personalization: ₹49 per line
    • Number Printing: ₹79 per number
    • Complex Design Processing: ₹149-₹299
    • Rush Processing (24hr): ₹199
    • Design Consultation: ₹299 (refundable on order)
    SHIPPING CHARGES:
    • Standard Shipping (3-7 days): ₹49
    • Express Shipping (1-3 days): ₹149
    • Same-day Delivery (Metro cities): ₹299
    • Free Shipping: Orders above ₹999
    • Bulk Order Shipping: Custom quotes
    ADDITIONAL CHARGES:
    • Gift Wrapping: ₹99
    • Special Packaging: ₹149
    • Greeting Card: ₹49
    • Personal Note: Free
    • GST (18%): Applied on total
    MINIMUM ORDER: ₹499
    MAXIMUM DISCOUNT APPLICABLE: 30%
    SHIPPING & DELIVERY:
    PROCESSING TIME:
    • Regular orders: 1-2 business days
    • Customized orders: 2-3 business days
    • Rush orders: 24 hours (+₹199)
    • Bulk orders: 3-5 business days
    DELIVERY TIMELINE:
    • Standard: 3-7 business days
    • Express: 1-3 business days
    • Same-day: Within 24 hours (selected cities)
    • International: 7-14 business days
    DELIVERY AREAS:
    • All over India (PIN code verification)
    • Metro cities: Delhi, Mumbai, Bangalore, Chennai, Kolkata, Hyderabad
    • Tier 2 & 3 cities
    • International shipping available (contact support)
    TRACKING:
    • Email/SMS tracking link after dispatch
    • Real-time updates
    • Delivery agent contact details
    • Estimated delivery time
    ORDER TRACKING STATUS FLOW:
    1. ORDER PLACED:
       • Confirmation email/SMS
       • Order number generated
       • Payment confirmation
    2. PROCESSING:
       • Design verification (for customized items)
       • Material sourcing
       • Production planning
    3. PRODUCTION:
       • Customization in progress
       • Quality check stage 1
       • Photography (if requested)
    4. QUALITY CHECK:
       • Final inspection
       • Packaging
       • Shipping label generation
    5. SHIPPED:
       • Handed to courier partner
       • Tracking number activated
       • Customer notification
    6. OUT FOR DELIVERY:
       • Local delivery center
       • Delivery executive assigned
       • Estimated time provided
    7. DELIVERED:
       • Delivery confirmation
       • Customer signature
       • Feedback request
    PAYMENT METHODS:
    1. CARDS:
       • Visa, MasterCard, Rupay
       • Debit/Credit cards
       • Secure 3D authentication
    2. UPI:
       • Google Pay
       • PhonePe
       • Paytm
       • BHIM UPI
       • Any UPI ID
    3. DIGITAL WALLETS:
       • Amazon Pay
       • MobiKwik
       • FreeCharge
       • Ola Money
    4. NET BANKING:
       • All major Indian banks
       • Instant payment
       • Secure gateway
    5. CASH ON DELIVERY:
       • Available for orders up to ₹5000
       • 100% advance for customized items
       • Shipping charges paid in advance
    6. EMI OPTIONS:
       • 3, 6, 9, 12 months
       • Zero-cost EMI available
       • Credit card EMI
       • Cardless EMI
    RETURN & REFUND POLICY:
    RETURN WINDOW: 7 days from delivery date
    CONDITIONS FOR RETURN:
    1. DEFECTIVE PRODUCTS:
       • Manufacturing defects
       • Printing errors
       • Color mismatches
       • Damaged during shipping
       • FULL REFUND or REPLACEMENT
    2. WRONG PRODUCTS:
       • Incorrect item shipped
       • Wrong size/color
       • Missing items
       • EXCHANGE or REFUND
    3. CUSTOMIZED PRODUCTS:
       • Generally not returnable
       • Only if defective
       • Design approval required before production
       • No returns for design choices
    4. NON-CUSTOMIZED PRODUCTS:
       • Unused condition
       • Original packaging
       • Tags attached
       • Full refund
    REFUND PROCESS:
    1. Initiate return request within 7 days
    2. Our team approves/contacts
    3. Pickup arranged (free for defective items)
    4. Quality check at warehouse
    5. Refund processed within 5-7 business days
    6. Refund method: Original payment mode
    CONTACT INFORMATION:
    CUSTOMER SUPPORT:
    • Phone: 1800-123-4567 (10 AM - 7 PM, Mon-Sat)
    • WhatsApp: +91-9876543210 (24/7)
    • Email: support@swagshack.com
    • Live Chat: Website (10 AM - 7 PM)
    SOCIAL MEDIA:
    • Instagram: @swagshack
    • Facebook: /swagshack
    • Twitter: @swagshack
    • Pinterest: /swagshack
    CORPORATE OFFICE:
    swagshack.
    123 Innovation Street,
    Tech Park, Andheri East,
    Mumbai, Maharashtra - 400093
    India
    GST NUMBER: 27AABCC1234D1Z2
    SPECIAL FEATURES:
    1. AI-POWERED DESIGN ASSISTANT:
       • Design suggestions based on product
       • Color harmony recommendations
       • Text placement optimization
       • Brand consistency checks
    2. 3D PRODUCT PREVIEW:
       • Real-time 3D rendering
       • Multiple angle views
       • Lighting simulation
       • Material texture preview
    3. BULK ORDER MANAGEMENT:
       • Minimum 10 pieces for bulk
       • Volume discounts
       • Consolidated shipping
       • Dedicated account manager
    4. CORPORATE GIFTING:
       • Branded merchandise
       • Employee gifts
       • Client appreciation
       • Event giveaways
    5. DESIGN TEMPLATES LIBRARY:
       • 1000+ pre-designed templates
       • Festival specials
       • Business templates
       • Social media templates
    6. COLOR MATCHING TOOL:
       • Pantone color matching
       • Brand color extraction
       • Complementary color suggestions
       • Print color simulation
    PROMOTIONS & DISCOUNTS:
    CURRENT OFFERS:
    • WELCOME15: 15% off first order (max discount ₹500)
    • FESTIVE30: 30% off on festival collections
    • BULK20: 20% off on 10+ items
    • STUDENT10: 10% off with valid ID
    • REFER200: ₹200 cashback for each referral
    SEASONAL SALES:
    • Republic Day Sale: Jan 15-26
    • Summer Sale: April-May
    • Independence Day Sale: Aug 1-15
    • Diwali Sale: October
    • Christmas Sale: Dec 15-31
    LOYALTY PROGRAM:
    • Sign up: ₹100 bonus
    • Every ₹1000 spent: 100 points
    • 100 points = ₹50 discount
    • Birthday month: 20% off
    • Anniversary specials
    IMPORTANT NOTES & POLICIES:
    1. CUSTOMIZATION FINALITY:
       • Once order confirmed, designs cannot be changed
       • Contact within 24 hours for modifications
       • Additional charges may apply
    2. COLOR VARIATIONS:
       • Screen colors vs print colors may differ slightly
       • Material texture affects color appearance
       • Request physical sample for exact color matching
    3. DESIGN APPROVAL:
       • All designs require approval before production
       • Approval time: 4-6 business hours
       • Rush approval: 2 hours (+₹99)
    4. FILE REQUIREMENTS:
       • Minimum 300 DPI resolution
       • Vector files preferred (SVG, AI)
       • CMYK color mode for printing
       • Transparent background for logos
    5. PRODUCTION TIMELINE:
       • Regular: 48-72 hours
       • Rush: 24 hours (+₹199)
       • Complex designs: Additional 24 hours
       • Weekends/holidays excluded
    6. SHIPPING RESTRICTIONS:
       • Certain remote locations: Additional charges
       • International: Customs duties extra
       • Hazardous materials: Cannot ship
       • Fragile items: Special packaging
    FAQ - FREQUENTLY ASKED QUESTIONS:
    Q1: How long does the entire process take?
    A: Design + Production + Shipping = 5-10 business days normally.
    Q2: Can I cancel my order?
    A: Only within 2 hours of order placement if not in production.
    Q3: Do you offer samples?
    A: Yes, sample kit available for ₹499 (refundable on first order).
    Q4: What's your quality guarantee?
    A: 100% quality guarantee. If not satisfied, we'll reprint or refund.
    Q5: Can I use copyrighted images?
    A: Only with proper authorization. We verify all uploads.
    Q6: How do I track my order?
    A: Use the tracking link in email/SMS or login to "My Orders".
    Q7: Do you offer design services?
    A: Yes, professional design services starting at ₹499.
    Q8: What if I receive wrong size?
    A: We'll arrange exchange within 7 days (free shipping).
    SUPPORT HOURS:
    • Monday to Saturday: 10:00 AM - 7:00 PM IST
    • Sunday: 10:00 AM - 2:00 PM IST
    • Emergency Support (WhatsApp): 24/7
    • Email Support: 24-hour response time
    TECHNICAL REQUIREMENTS:
    • Browser: Chrome 80+, Firefox 75+, Safari 13+
    • Internet: Minimum 2 Mbps for design tool
    • Device: Desktop recommended for best experience
    • Cookies: Must be enabled for shopping cart
    PRIVACY & SECURITY:
    • SSL encrypted website
    • Secure payment gateway
    • Data protection compliant
    • No storage of payment details
    `;
    const systemPrompt = `You are an AI shopping assistant for "My Swag Shack" - an e-commerce platform specializing in customized products.
    YOUR IDENTITY: My Swag Shack AI Assistant
    YOUR PURPOSE: Help customers with product information, customization guidance, pricing, shipping, and order support
    RESPONSE GUIDELINES:
    1. Always be polite, professional, and helpful
    2. Use the website information provided above for accurate responses
    3. Structure complex information with bullet points or numbered lists
    4. Keep responses concise but informative
    5. If you don't know something, say you need to check with support
    7. Mention relevant promotions if applicable
    8. End with a follow-up question to continue conversation
    FORMATTING:
    • Use **bold** for important terms
    • Use emojis sparingly (👉, ✅, ⭐, 🚚, 💰, 🎨)
    • Separate sections with clear spacing
    • Use headings for different topics
    LIMITATIONS:
    • You cannot process orders
    • You cannot access customer accounts
    • You cannot provide real-time tracking
    • You cannot handle payments
    • For urgent issues, direct to support contact
    Now, based on the comprehensive website information provided, help the customer with their query:`;
    useEffect(() => {
        if (isOpen && messages.length === 0) {
            setMessages([
                {
                    id: 1,
                    text: `👋 **Welcome to My Swag Shack!**\n\nI'm your AI shopping assistant, here to help you create amazing custom products.\n\n**I can assist you with:**\n\n🎨 **Customization Help**\n• AI Logo Generator process\n• Text & number personalization\n• Design upload guidelines\n• Color matching advice\n\n🛍️ **Product Information**\n• Browse 4 categories: Apparel, Accessories, Office, Home\n• Pricing details for all items\n• Material and quality information\n\n📦 **Order Support**\n• Step-by-step customization process\n• Shipping options & delivery times\n• Payment methods including COD\n• Order tracking guidance\n\n💰 **Pricing & Offers**\n• Current promotions and discounts\n• Customization charges\n• Bulk order pricing\n• Student discounts\n\n🔧 **Policy Information**\n• Return & refund policy\n• Contact support details\n• FAQ answers\n\n**Quick Tip:** Use the buttons below for common questions, or type your specific query.\n\n**How can I help you create something special today?**`,
                    sender: 'bot',
                    timestamp: new Date()
                }
            ]);
        }
    }, [isOpen]);
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);
    useEffect(() => {
        if (isOpen && inputRef.current) {
            setTimeout(() => inputRef.current.focus(), 300);
        }
    }, [isOpen]);
    const handleSendMessage = async () => {
        if (!inputMessage.trim()) return;
        const userMessage = {
            id: messages.length + 1,
            text: inputMessage,
            sender: 'user',
            timestamp: new Date()
        };
        setMessages(prev => [...prev, userMessage]);
        const currentInput = inputMessage;
        setInputMessage('');
        setIsLoading(true);
        try {
            const conversationHistory = messages.slice(-3).map(msg =>
                `${msg.sender === 'user' ? 'Customer' : 'Assistant'}: ${msg.text}`
            ).join('\n\n');
            const fullPrompt = `
            ${systemPrompt}
            WEBSITE INFORMATION FOR REFERENCE:
            ${websiteInformation}
            CONVERSATION HISTORY:
            ${conversationHistory}
            CUSTOMER'S CURRENT QUERY:
            "${currentInput}"
            Please provide a helpful, accurate response based on the website information. 
            Include specific details like pricing, processes, or policies when relevant.
            Make the response friendly and engaging while being professional.
            If the query requires human assistance, politely direct to support.
            `;
            const response = await axios.post(
                GEMINI_API_URL,
                {
                    contents: [
                        {
                            parts: [
                                {
                                    text: fullPrompt
                                }
                            ]
                        }
                    ],
                    generationConfig: {
                        temperature: 0.7,
                        topP: 0.95,
                        topK: 40,
                        maxOutputTokens: 1024,
                    },
                    safetySettings: [
                        {
                            category: "HARM_CATEGORY_HARASSMENT",
                            threshold: "BLOCK_MEDIUM_AND_ABOVE"
                        },
                        {
                            category: "HARM_CATEGORY_HATE_SPEECH",
                            threshold: "BLOCK_MEDIUM_AND_ABOVE"
                        },
                        {
                            category: "HARM_CATEGORY_SEXUALLY_EXPLICIT",
                            threshold: "BLOCK_MEDIUM_AND_ABOVE"
                        },
                        {
                            category: "HARM_CATEGORY_DANGEROUS_CONTENT",
                            threshold: "BLOCK_MEDIUM_AND_ABOVE"
                        }
                    ]
                },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            let botResponse = '';
            if (response.data && response.data.candidates && response.data.candidates[0]) {
                botResponse = response.data.candidates[0].content.parts[0].text;
            } else {
                throw new Error('Invalid response format from Gemini API');
            }
            const botMessage = {
                id: messages.length + 2,
                text: botResponse,
                sender: 'bot',
                timestamp: new Date()
            };
            setMessages(prev => [...prev, botMessage]);
        } catch (error) {
            console.error('Error calling Gemini API:', error);
            let errorResponse = "";
            const query = currentInput.toLowerCase();
            if (query.includes('custom') || query.includes('design') || query.includes('logo')) {
                errorResponse = `I'm having trouble accessing detailed information right now. \n\nFor **customization help**, here are the basics:\n• Visit any product page → Click "Customize"\n• Choose from: AI Logo, Text, Numbers, or Upload\n• Use the editor to position your design\n• Preview before adding to cart\n\n**Customization Charges:**\n• AI Logo/Image: ₹99\n• Text: ₹49 per line\n• Numbers: ₹79 per number\n\nFor detailed guidance, please contact our design team at support@swagshack.com or call 1800-123-4567.`;
            } else if (query.includes('price') || query.includes('cost') || query.includes('charge')) {
                errorResponse = `I'm experiencing technical difficulties. Here's **general pricing**:\n\n**T-shirts:** ₹499-₹1299\n**Hoodies:** ₹899-₹1999\n**Mugs:** ₹299-₹599\n**Phone Cases:** ₹399-₹799\n\n**Customization:** ₹49-₹299 extra\n**Shipping:** ₹49 standard, free above ₹999\n\nFor exact pricing or quotes, please check the product pages or contact support.`;
            } else if (query.includes('ship') || query.includes('deliver') || query.includes('track')) {
                errorResponse = `**Shipping Information:**\n• Processing: 1-3 business days\n• Delivery: 3-7 days (Standard), 1-3 days (Express)\n• COD available up to ₹5000\n• Track orders via email/SMS link\n\nFor specific tracking or delivery queries, please contact support@swagshack.com with your order number.`;
            } else {
                errorResponse = "I apologize, but I'm having trouble processing your request right now. Please try again in a moment or contact our support team for immediate assistance:\n\n📞 **Phone:** 1800-123-4567 (10 AM - 7 PM)\n📱 **WhatsApp:** +91-9876543210\n✉️ **Email:** support@swagshack.com\n\nYou can also:\n1. Check our FAQ section on the website\n2. Browse products directly\n3. Try rephrasing your question";
            }
            const errorMessage = {
                id: messages.length + 2,
                text: errorResponse,
                sender: 'bot',
                timestamp: new Date()
            };
            setMessages(prev => [...prev, errorMessage]);
        } finally {
            setIsLoading(false);
        }
    };
    const handleQuickAction = (action) => {
        const quickQuestions = {
            'customize': 'Can you explain the complete step-by-step process to customize a product from start to finish?',
            'products': 'What are all the product categories you offer and what customization options are available for each?',
            'logo': 'How does the AI Logo Generator work exactly? What are all the features and how do I use the generated logos?',
            'pricing': 'What are the detailed pricing for all products including base prices and customization charges?',
            'shipping': 'What are all shipping options, their costs, delivery times, and how do I track my order?',
            'payment': 'What payment methods do you accept? Is Cash on Delivery available and what are the limits?',
            'return': 'What is your complete return and refund policy for both customized and non-customized products?',
            'promotions': 'What are all current promotions, discount codes, and how do I apply them?',
            'bulk': 'Do you offer bulk order discounts? What is the minimum quantity and how much discount?',
            'contact': 'How do I contact customer support and what are their working hours?'
        };
        const message = quickQuestions[action] || action;
        setInputMessage(message);
        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 50);
        setQuickActionTriggered(true);
        setTimeout(() => setQuickActionTriggered(false), 1000);
    };
    const handleMouseDown = (e) => {
        if (e.target.closest('.chatbot-header-draggable')) {
            const rect = modalRef.current.getBoundingClientRect();
            setIsDragging(true);
            setDragOffset({
                x: e.clientX - rect.left,
                y: e.clientY - rect.top
            });
            setPosition({
                left: rect.left,
                top: rect.top,
                right: null
            });
            e.preventDefault();
        }
    };
    const handleMouseMove = (e) => {
        if (!isDragging || !modalRef.current) return;
        const rect = modalRef.current.getBoundingClientRect();
        const newLeft = e.clientX - dragOffset.x;
        const newTop = e.clientY - dragOffset.y;
        const padding = 8;
        const minLeft = padding;
        const minTop = padding;
        const maxLeft =
            window.innerWidth - rect.width - padding;
        const maxTop =
            window.innerHeight - rect.height - padding;
        setPosition(prev => ({
            ...prev,
            left: Math.max(minLeft, Math.min(newLeft, maxLeft)),
            top: Math.max(minTop, Math.min(newTop, maxTop))
        }));
    };
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isDragging]);
    const clearChat = () => {
        setMessages([
            {
                id: 1,
                text: `👋 **Welcome to swagshack!**\n\nI'm your AI shopping assistant, here to help you create amazing custom products.\n\n**I can assist you with:**\n\n🎨 **Customization Help**\n• AI Logo Generator process\n• Text & number personalization\n• Design upload guidelines\n• Color matching advice\n\n🛍️ **Product Information**\n• Browse 4 categories: Apparel, Accessories, Office, Home\n• Pricing details for all items\n• Material and quality information\n\n📦 **Order Support**\n• Step-by-step customization process\n• Shipping options & delivery times\n• Payment methods including COD\n• Order tracking guidance\n\n💰 **Pricing & Offers**\n• Current promotions and discounts\n• Customization charges\n• Bulk order pricing\n• Student discounts\n\n🔧 **Policy Information**\n• Return & refund policy\n• Contact support details\n• FAQ answers\n\n**Quick Tip:** Use the buttons below for common questions, or type your specific query.\n\n**How can I help you create something special today?**`,
                sender: 'bot',
                timestamp: new Date()
            }
        ]);
    };
    const handleInputChange = (e) => {
        setInputMessage(e.target.value);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    if (!isOpen && isMinimized) {
        return (
            <button
                className="chatbot-floating-btn minimized"
                onClick={() => setIsMinimized(false)}
            >
                <BotSvg />
            </button>
        );
    }
    if (!isOpen) {
        return (
            <button
                className="chatbot-floating-btn"
                title='Open Chatbot'
                onClick={() => setIsOpen(true)}
            >
                <BotSvg />
                <span>AI Assistant</span>
            </button>
        );
    }
    return (
        <div
            ref={modalRef}
            className="modal show d-block chatbot-modal-overlay"
            style={{
                position: 'fixed',
                left: position.left !== null ? `${position.left}px` : 'auto',
                right: position.right !== null ? `${position.right}px` : 'auto',
                top: `${position.top}px`,
                margin: 0,
                zIndex: 9999,
                cursor: isDragging ? 'grabbing' : 'default'
            }}
            onMouseDown={handleMouseDown}
            onClick={() => !isMinimized && setIsOpen(false)}
        >
            <div
                className={`modal-dialog modal-dialog-centered ${isMinimized ? 'chatbot-minimized' : 'chatbot-modal-dialog'}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content chatbot-modal-content">
                    <div
                        className="modal-header justify-content-between align-items-start border-0 chatbot-header-draggable chatbot-modal-header"
                        style={{ cursor: 'move' }}
                    >
                        <div>
                            <h5 className="modal-title mb-0 chatbot-modal-title">
                                <BotSvg className="me-2" />
                                AI Assistant
                            </h5>
                            <p className="chatbot-modal-subtitle mb-1">
                                Get help with customization, pricing, shipping & more
                            </p>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <button
                                type="button"
                                className="chatbot-icon-btn"
                                onClick={clearChat}
                                title="Clear chat"
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.1042 7.89062C16.1042 7.89062 15.6517 13.5031 15.3892 15.8673C15.2642 16.9965 14.5667 17.6581 13.4242 17.679C11.25 17.7181 9.07332 17.7206 6.89999 17.6748C5.80082 17.6523 5.11499 16.9823 4.99249 15.8731C4.72832 13.4881 4.27832 7.89062 4.27832 7.89062" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M17.2567 5.19987H3.125" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                    <path d="M14.5335 5.20047C13.8793 5.20047 13.316 4.73797 13.1877 4.09714L12.9852 3.0838C12.8602 2.6163 12.4368 2.29297 11.9543 2.29297H8.42682C7.94432 2.29297 7.52099 2.6163 7.39599 3.0838L7.19349 4.09714C7.06516 4.73797 6.50182 5.20047 5.84766 5.20047" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="chatbot-close-btn"
                                onClick={() => setIsOpen(false)}
                                aria-label="Close"
                                title='Close'
                            >
                                <CloseSvg />
                            </button>
                        </div>
                    </div>
                    {!isMinimized && (
                        <>
                            <div className="modal-body chatbot-modal-body">
                                <div className="chatbot-quick-actions mb-3">
                                    <p className="chatbot-quick-actions-title">Quick help topics:</p>
                                    <div className="d-flex flex-wrap gap-2">
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('customize')}
                                            disabled={isLoading}
                                        >
                                            🎨 How to Customize
                                        </button>
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('logo')}
                                            disabled={isLoading}
                                        >
                                            🤖 AI Logo Generator
                                        </button>
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('pricing')}
                                            disabled={isLoading}
                                        >
                                            💰 Pricing Details
                                        </button>
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('shipping')}
                                            disabled={isLoading}
                                        >
                                            🚚 Shipping Info
                                        </button>
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('return')}
                                            disabled={isLoading}
                                        >
                                            ↩️ Return Policy
                                        </button>
                                        <button
                                            className="chatbot-quick-btn"
                                            onClick={() => handleQuickAction('bulk')}
                                            disabled={isLoading}
                                        >
                                            📦 Bulk Orders
                                        </button>
                                    </div>
                                </div>
                                <div className="chatbot-messages">
                                    {messages.map((message) => (
                                        <div
                                            key={message.id}
                                            className={`chatbot-message ${message.sender === 'user' ? 'user-message' : 'bot-message'}`}
                                        >
                                            <div className="chatbot-message-avatar">
                                                {message.sender === 'bot' ? <BotSvg /> : <UserSvg />}
                                            </div>
                                            <div className="chatbot-message-content">
                                                <div className="chatbot-message-text">
                                                    {message.text.split('\n').map((line, i) => (
                                                        <p key={i} className="mb-1">{line}</p>
                                                    ))}
                                                </div>
                                                <div className="chatbot-message-time">
                                                    {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {isLoading && (
                                        <div className="chatbot-message bot-message">
                                            <div className="chatbot-message-avatar">
                                                <BotSvg />
                                            </div>
                                            <div className="chatbot-message-content">
                                                <div className="chatbot-loading">
                                                    <LoadingSvg />
                                                    <span>Thinking...</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div ref={messagesEndRef} />
                                </div>
                            </div>
                            <div className="modal-footer border-0 chatbot-modal-footer">
                                <div className="input-group chatbot-input-group">
                                    <input
                                        ref={inputRef}
                                        className="form-control chatbot-input"
                                        value={inputMessage}
                                        onChange={handleInputChange}
                                        onKeyPress={handleKeyPress}
                                        placeholder="Ask about products, customization, pricing, shipping, returns..."
                                        readOnly={isLoading}
                                    />
                                    <button
                                        className="btn chatbot-send-btn"
                                        onClick={handleSendMessage}
                                        disabled={!inputMessage.trim() || isLoading}
                                    >
                                        <SendSvg />
                                    </button>
                                </div>
                                <div className="chatbot-disclaimer">
                                    🤖 AI-powered assistant • My Swag Shack • Responses based on website information
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Chatbot;